import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ResultAnalyzerService} from "../../services/result-analyzer.service";
import {DxAccordionModule, DxScrollViewModule} from "devextreme-angular";
import {take} from "rxjs/operators";
import {Observable} from "rxjs";
import {ResultAnalysis} from "../../models/result-analysis";


@Component({
  selector: 'app-ai-analysis-viewer',
  standalone: true,
  imports: [CommonModule, DxAccordionModule, DxScrollViewModule],
  templateUrl: './ai-analysis-viewer.component.html',
  styleUrls: ['./ai-analysis-viewer.component.scss']
})
export class AiAnalysisViewerComponent implements OnChanges {
  @Input() orderCode?: string;
  @Input() clientCode?: string;
  exists$?: Observable<boolean>;
  clientEnabled$?: Observable<boolean>;
  analyzes$?: Observable<ResultAnalysis[]>;

  constructor(public service: ResultAnalyzerService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.orderCode && changes.orderCode.currentValue) {
      this.exists$ = this.service.checkIfOrderHasBeenAnalyzed(changes.orderCode.currentValue)
        .pipe(take(1));

      this.clientEnabled$ = this.service.checkClient(changes.clientCode.currentValue)
        .pipe(take(1));

      this.analyzes$ = this.service.getOrderAnalyzes(changes.orderCode.currentValue)
        .pipe(take(1));
    }
  }

}
